import styled from 'styled-components'

export const StyledNavBarContainer = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    width: 300px;
    height: 100%;
    z-index: 100;
    background: white;
    opacity: 90%;
    margin: 15px;
`